import { render, staticRenderFns } from "./dependent-vendors-modal.vue?vue&type=template&id=24e26604&scoped=true&"
import script from "./dependent-vendors-modal.vue?vue&type=script&lang=js&"
export * from "./dependent-vendors-modal.vue?vue&type=script&lang=js&"
import style0 from "./dependent-vendors-modal.vue?vue&type=style&index=0&id=24e26604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e26604",
  null
  
)

export default component.exports